import { styledOmitCustomProps } from '@braskai/ui-kit';

import { css, styled, Theme } from '@mui/material';

import { BUSINESS_BACKGROUND_COLOR, ENTERPRISE_BACKGROUND_COLOR } from '@/widgets/pricing/pricingCards/lib/constants';

export const SContainer = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    margin-top: 8px;
    gap: 16px;

    ${theme.breakpoints.up('tablet')} {
      margin-bottom: 16px;
    }
  `,
);

export const SPriceContainer = styled('div')(
  () => css`
    display: flex;
    align-items: center;
    gap: 4px;
  `,
);

type TSCard = {
  $isBusiness: boolean;
  $isDisabled: boolean;
  $isEnterprise: boolean;
  $isOutlined: boolean;
};

const getBackgroundColor = (
  isOutlined: boolean,
  isEnterprise: boolean,
  isBusiness: boolean,
  isDisabled: boolean,
  theme: Theme,
) => {
  const defaultStyle = theme.palette.grey[50];

  if (isDisabled) return defaultStyle;

  if (isOutlined) return 'inherit';
  if (isEnterprise) return ENTERPRISE_BACKGROUND_COLOR;
  if (isBusiness) return BUSINESS_BACKGROUND_COLOR;

  return defaultStyle;
};

const getBorderColor = (
  isOutlined: boolean,
  isEnterprise: boolean,
  isBusiness: boolean,
  isDisabled: boolean,
  theme: Theme,
) => {
  const defaultStyle = 'transparent';

  if (isDisabled) return defaultStyle;

  if (isOutlined) return theme.palette.grey[200];
  if (isEnterprise) return ENTERPRISE_BACKGROUND_COLOR;
  if (isBusiness) return BUSINESS_BACKGROUND_COLOR;
  return defaultStyle;
};

export const SCard = styled(
  'div',
  styledOmitCustomProps,
)<TSCard>(
  ({ theme, $isOutlined, $isEnterprise, $isBusiness, $isDisabled }) => css`
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    box-sizing: border-box;
    border: 1px solid ${getBorderColor($isOutlined, $isEnterprise, $isBusiness, $isDisabled, theme)};
    background-color: ${getBackgroundColor($isOutlined, $isEnterprise, $isBusiness, $isDisabled, theme)};
  `,
);

export const SCardContent = styled('div')(
  () => css`
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 12px 8px;
  `,
);

export const SCurrentPlanContainer = styled('div')(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 36px;
    border-bottom: 1px solid ${theme.palette.grey[200]};
    box-sizing: border-box;
  `,
);
